import { render } from "./CourseListContents.vue?vue&type=template&id=2a8db0b2&ts=true"
import script from "./CourseListContents.vue?vue&type=script&lang=ts"
export * from "./CourseListContents.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__